import React from 'react';
import { Chip } from '@mui/material';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ExpiredIcon from '@mui/icons-material/EventBusy';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * ContractStatusBadge Component
 * Displays contract status with appropriate color and icon
 */
const ContractStatusBadge = ({ status, size = 'medium' }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'draft':
        return {
          label: 'Draft',
          color: 'default',
          icon: <DraftsIcon />
        };
      case 'sent':
        return {
          label: 'Sent',
          color: 'info',
          icon: <SendIcon />
        };
      case 'signed':
        return {
          label: 'Signed',
          color: 'success',
          icon: <CheckCircleIcon />
        };
      case 'expired':
        return {
          label: 'Expired',
          color: 'warning',
          icon: <ExpiredIcon />
        };
      case 'cancelled':
        return {
          label: 'Cancelled',
          color: 'error',
          icon: <CancelIcon />
        };
      default:
        return {
          label: status || 'Unknown',
          color: 'default',
          icon: null
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      color={config.color}
      icon={config.icon}
      size={size}
      sx={{ fontWeight: 500 }}
    />
  );
};

export default ContractStatusBadge;
